










































































































import BaseComponent from '@/components/base-component.vue';
import PatientForm from '@/components/patients/patient-form.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiGenderPicker from '@/components/UI/gender-picker.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { PacienteFiltroDTO } from '@/interfaces/patient';
import PatientModel from '@/models/patient-model';
import * as service from '@/services/patients';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    PatientForm,
    UiToggleStatus,
    UiAutocompleClientsSubsidiaries,
    UiGenderPicker,
    UiDatePicker
  },
})
export default class Patients extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public pagina: ResultPagDTO<any> = new ResultPagDTO();

  public filter: any = {
    term: '',
  };

  public headers: any = [
    { text: 'Nome', value: 'nome' },
    { text: 'Data de Nasc.', value: 'nascimento' },
    { text: 'Sexo', value: 'sexo' },
    { text: 'Unidades', value: 'unidades', sortable: false },
    { text: 'Agrupado', value: 'agrupado', sortable: false, align: 'center' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public items: any[] = [];
  public idEdit = null;

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  public beforeMount(): void {
    this.search();
  }

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listPatients(filter);
        }),
      )
      .subscribe((result) => {
        this.items = result.content;
        this.loading = false;
        this.pagina = result;
        PaginationSyncDTO.update(this.pagination, result);
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  public onChangeFilter(): void {
    this.pagination.page = 1;
    this.search();
  }

  public onEditItem(item): void {
    this.idEdit = item.id;
    this.formOpen = true;
  }

  public saveItem(item: PatientModel): void {
    this.closeForm();
    this.search();
  }

  public newItem(): void {
    this.idEdit = null;
    this.formOpen = true;
  }

  public closeForm(): void {
    this.idEdit = null;
    this.formOpen = false;
    resetModalScroll();
  }

  private search(): void {
    this.items = [];
    this.loading = true;    
    let idUnidade =  this.filter.unidade ? this.filter.unidade.id : null;
    
    this.filter.oldTerm = this.filter.term;
    let parm = new PacienteFiltroDTO();
    parm.nome = this.filter.term;
    parm.idUnidade = idUnidade;
    parm.nascimento = this.filter.nascimento;
    parm.sexo = this.filter.sexo;
    parm.ativo = this.filter.ativo;
    parm.agrupado = this.filter.agrupado;

    parm.update(this.pagination);
    this.execBehaviorSub$.next(parm);
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    this.search();
  }

  onMergedPatient(res) {
    this.search();
  }
}
